import ServiceBus from 'servicestack/service-bus'
import ModalController from 'webmodals/modal.controller'
import labels from 'emun.on-demand/admin/_labels'
import modals from 'webmodals/modals'


class EditProductPromptController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        $ctrl.bus = new ServiceBus()
        $ctrl.title = options.title || 'Edit Product Info...';
        $ctrl.subTitle = options.subTitle;
        $ctrl.product = options.product;
        $ctrl.labels = labels;

        $ctrl.request = Object.assign({}, options.product);
        console.debug('EditProductPromptController', options);
    }

    $onInit() {
        this.message = 'Loading Tags';
        ServiceBus.read('QueryProductTagKinds.json').then(res => {
            console.debug('QueryProductTagKinds', res);
            res.data.results.forEach(r => this.addTagKind(r.tagKind));
            this.message = false;
        });
    }

    addTagKindPrompt() {
        modals.prompt('Add Tag Kind...')
            .result
            .then(tk => this.addTagKind(tk));
    }

    addTagKind(tk) {
        if (!this.request)
            this.request = {};
        if (!this.request.tags)
            this.request.tags = {};
        if (!this.request.tags[tk])
            this.request.tags[tk] = [];
    }

    submit() {
        const $ctrl = this;
        $ctrl.bus.send("UpdateProduct.json", $ctrl.request).then(res => {
            $ctrl.close({update:res.data});
        });
    }
}


export default EditProductPromptController;